import React, {useState, useContext, useEffect} from 'react'
import { Row, Col, Pagination  } from "antd";
import { EyeFilled  } from '@ant-design/icons';
import { AppContext } from '../../util/context';
import "../../pages/Home/Home.css";
import dayjs from 'dayjs';

export const DataView = ({cards, current, setDetailsViewModal}) => {
    const {
        StyledDiv
    } = useContext(AppContext)
    
    const [filteredItems, setFilteredItems] = useState(cards)

    const [paginationDetails, setPaginationDetails] = useState({
        currentPage: 1,
        itemsPerPage: ['mycards', 'myteamscards', 'allcards', 'assignedactionstoteam'].includes(current) ? 6 : 5,
        indexOfLastItem: 0,
        indexOfFirstItem: 0,
    })

    const handleChange = (page) => { 
        const indexOfLastItem = page * paginationDetails.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - paginationDetails.itemsPerPage;
    
        const currentList = cards.slice(indexOfFirstItem, indexOfLastItem);
        setFilteredItems(currentList);
        setPaginationDetails({...paginationDetails, indexOfLastItem, indexOfFirstItem, currentPage: page});
    }

    useEffect(() => {
        let mounted = true;

        if(mounted){
            const maxPageData = ['mycards', 'myteamscards', 'allcards', 'assignedactionstoteam'].includes(current) ? 6 : 5;
            manageData(maxPageData);
        }

        return () => {
            mounted = false;
        }
    }, [cards, current])

    const manageData = (maxPageData) => {
        if(cards.length > 0){
            const indexOfLastItem = 1 * maxPageData;
            const indexOfFirstItem = indexOfLastItem - maxPageData;
            const currentList = cards.slice(indexOfFirstItem, indexOfLastItem);
            setFilteredItems(currentList);
            setPaginationDetails(prev => ({
                ...prev,
                currentPage: 1,
                itemsPerPage: ['mycards', 'myteamscards', 'allcards', 'assignedactionstoteam'].includes(current) ? 6 : 5,
                indexOfLastItem: indexOfLastItem,
                indexOfFirstItem: indexOfFirstItem,
            }));
        }else{
            setFilteredItems([])
        }
    } 

    return (
        <>
            <Row
                style={{
                    height: "90%",
                    padding: "15px",
                }}
                
                className="dataViewContainer"
            >
                <Col
                    span={24}
                >
                    <Row
                        style={{
                            height: "5%",
                        }}
                    >
                        <Col
                            span={24}
                        >
                            {(current === 'mycards' || current === 'myteamscards') && <Row>
                                <Col
                                    xl={{span: 3}}
                                    lg={{span: 3}}
                                    md={{span: 8}}
                                    sm={{span: 7}}
                                    xs={{span: 7}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Code
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 2}}
                                    sm={{span: 5}}
                                    xs={{span: 5}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                    
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Date Observed
                                    </StyledDiv>
                                </Col>

                                {current === "myteamscards" && <Col
                                    xl={{span: 3}}
                                    lg={{span: 3}}
                                    md={{span: 3}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                >
                                     <StyledDiv
                                        className="columnText"
                                    >
                                        Created By
                                    </StyledDiv>
                                </Col>}

                                <Col
                                    xl={{span: 3}}
                                    lg={{span: 3}}
                                    md={{span: 3}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Observation Type
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: current === "mycards" ? 10 : 7}}
                                    lg={{span: current === "mycards" ? 10 : 7}}
                                    md={{span: current === "mycards" ? 10 : 7}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Observation Description
                                    </StyledDiv>
                                </Col>

                                

                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 2}}
                                    sm={{span: 4}}
                                    xs={{span: 4}}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Actions
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 7}}
                                    sm={{span: 7}}
                                    xs={{span: 7}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Status
                                    </StyledDiv>
                                </Col>

                            </Row>}

                            {(current === 'myactions' || current === 'assignedactions') && <Row>
                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 6}}
                                    sm={{span: 6}}
                                    xs={{span: 6}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Card ID
                                    </StyledDiv>
                                </Col>
                                
                                <Col
                                    xl={{span: 7}}
                                    lg={{span: 7}}
                                    md={{span: 7}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                    
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Action
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 4}}
                                    lg={{span: 4}}
                                    md={{span: 9}}
                                    sm={{span: 9}}
                                    xs={{span: 9}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        {current === 'myactions' ? 'Date Observed' : 'Due Date' }
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 5}}
                                    lg={{span: 5}}
                                    md={{span: 5}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        {current === 'myactions' ? 'Assigned To' : 'Location'}
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 5}}
                                    sm={{span: 5}}
                                    xs={{span: 5}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Status
                                    </StyledDiv>
                                </Col>

                            </Row>}

                            {current === 'allcards' && <Row>
                                <Col
                                    xl={{span: 3}}
                                    lg={{span: 3}}
                                    md={{span: 6}}
                                    sm={{span: 6}}
                                    xs={{span: 6}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Card ID
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 3}}
                                    lg={{span: 3}}
                                    md={{span: 9}}
                                    sm={{span: 9}}
                                    xs={{span: 9}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Date Observed
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 3}}
                                    lg={{span: 3}}
                                    md={{span: 3}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Created By
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 3}}
                                    lg={{span: 3}}
                                    md={{span: 3}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Observation Type
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 6}}
                                    lg={{span: 6}}
                                    md={{span: 6}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Observation Description
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 0}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Actions
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 4}}
                                    sm={{span: 4}}
                                    xs={{span: 4}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Status
                                    </StyledDiv>
                                </Col>
                            </Row>}

                            {(current === 'allactions' || current === 'assignedactionstoteam') && <Row>
                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 6}}
                                    sm={{span: 6}}
                                    xs={{span: 6}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Card ID
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 7}}
                                    lg={{span: 7}}
                                    md={{span: 7}}
                                    sm={{span: 0}}
                                    xs={{span: 0}}
                                    className="columnContainer"
                                    
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Action
                                    </StyledDiv>
                                </Col>

                                <Col
                                    span={4}
                                    className="columnContainer"
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Due Date
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 5}}
                                    lg={{span: 5}}
                                    md={{span: 9}}
                                    sm={{span: 9}}
                                    xs={{span: 9}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Assigned To
                                    </StyledDiv>
                                </Col>

                                <Col
                                    xl={{span: 2}}
                                    lg={{span: 2}}
                                    md={{span: 5}}
                                    sm={{span: 5}}
                                    xs={{span: 5}}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <StyledDiv
                                        className="columnText"
                                    >
                                        Status
                                    </StyledDiv>
                                </Col>

                            </Row>}

                            <Row>
                                <Col span={24}>
                                    <hr style={{
                                        backgroundColor: "#FBFBFB"
                                    }}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    

                    <Row
                        style={{
                            height: "90%",
                        }}
                    >
                        <Col span={24}>
                            {filteredItems && filteredItems.map((data, index) => {
                                const dueDate = dayjs(data.dueDate, 'YYYY-MM-DD');
                                const today = dayjs();

                                const overDue = (current === 'assignedactions' || current === 'allactions') && dueDate.isBefore(today, 'day');
                                //console.log(data)
                                return(
                                    <React.Fragment key = {index}>
                                        {(current === 'mycards' || current === 'myteamscards') && <Row
                                            style={{
                                                minHeight: "66px",
                                                display: "flex",
                                                alignItems: "center",
                                                borderBottom: "1px solid #E8E8E8",
                                                paddingTop: "10px",
                                                paddingBottom: "10px"
                                            }}
                                        >
                                            <Col
                                                xl={{span: 3}}
                                                lg={{span: 3}}
                                                md={{span: 8}}
                                                sm={{span: 7}}
                                                xs={{span: 7}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.HZDID}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 2}}
                                                sm={{span: 5}}
                                                xs={{span: 5}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                                
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.dateObserved}
                                                </StyledDiv>
                                            </Col>

                                            {current === 'myteamscards' && <Col
                                                xl={{span: 3}}
                                                lg={{span: 3}}
                                                md={{span: 3}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                            >
                                                 <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.createdBy}
                                                </StyledDiv>
                                            </Col>}

                                            <Col
                                                xl={{span: 3}}
                                                lg={{span: 3}}
                                                md={{span: 3}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.observationType}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: current === "mycards" ? 10 : 7}}
                                                lg={{span: current === "mycards" ? 10 : 7}}
                                                md={{span: current === "mycards" ? 10 : 7}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                                style={{
                                                    maxHeight: "100px", 
                                                    overflowX: "hidden",
                                                    overflowY: "auto",
                                                    
                                                }}
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.observationDescription}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 4}}
                                                sm={{span: 4}}
                                                xs={{span: 4}}
                                                className="columnContainer"
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.actions && data.actions.length > 0 ? data.actions.length : 0}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 7}}
                                                sm={{span: 7}}
                                                xs={{span: 7}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <div
                                                    className={data.status === 'open'?
                                                        "statusContainer openStatus" : data.status === 'assigned' ?
                                                            "statusContainer assignedStatus" : data.status === 'closed' ?
                                                                "statusContainer closedStatus" : data.status === 'void' ?
                                                                        "statusContainer voidStatus" : "statusContainer"
                                                    }
                                                >
                                                    <StyledDiv
                                                        className="dataText"
                                                    >
                                                        {data.status.toUpperCase()}
                                                    </StyledDiv>
                                                </div>
                                                
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 5}}
                                                sm={{span: 5}}
                                                xs={{span: 5}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <EyeFilled 
                                                    className="viewIcon"
                                                    onClick = {() => setDetailsViewModal({show: true, id: data.id})}
                                                />
                                            </Col>
                                        </Row>}

                                        {(current === 'myactions' || current === 'assignedactions') && <Row
                                            style={{
                                                minHeight: "66px",
                                                display: "flex",
                                                alignItems: "center",
                                                borderBottom: "1px solid #E8E8E8",
                                                paddingTop: "10px",
                                                paddingBottom: "10px"
                                            }}
                                        >
                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 6}}
                                                sm={{span: 6}}
                                                xs={{span: 6}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.HZDID}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 7}}
                                                lg={{span: 7}}
                                                md={{span: 7}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                                
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.action}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 4}}
                                                lg={{span: 4}}
                                                md={{span: 9}}
                                                sm={{span: 9}}
                                                xs={{span: 9}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <StyledDiv
                                                    className={(overDue && (data.status === 'assigned' || data.status === 'reassigned')) ? "dueDateDataText dataText" : "dataText"}
                                                >
                                                    {current === 'myactions' ? data.dateObserved : data.dueDate }
                                                    {((data.status === 'assigned' || data.status === 'reassigned') && current === 'assignedactions' && overDue) ? "!" : ""}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 5}}
                                                lg={{span: 5}}
                                                md={{span: 5}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {current === 'myactions' ? data.assignedTo : data.location}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 5}}
                                                sm={{span: 5}}
                                                xs={{span: 5}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <div
                                                    className={data.status === 'open'?
                                                        "statusContainer openStatus" : data.status === 'assigned' || data.status === 'reassigned' ?
                                                            "statusContainer assignedStatus" : data.status === 'closed' ?
                                                                "statusContainer closedStatus" : data.status === 'completed' ?
                                                                    "statusContainer completedStatus" : data.status === 'void' ?
                                                                        "statusContainer voidStatus" : "statusContainer"
                                                    }
                                                >
                                                    <StyledDiv
                                                        className="dataText"
                                                    >
                                                        {data.status.toUpperCase()}
                                                    </StyledDiv>
                                                </div>
                                                
                                            </Col>

                                            <Col
                                                span={4}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <EyeFilled 
                                                    className="viewIcon"
                                                    onClick = {() => setDetailsViewModal({
                                                        show: true, 
                                                        id: current === 'myactions' ? data.cardID : data.Hazard.id,
                                                        actionID: data.id
                                                    })}
                                                />
                                            </Col>
                                        </Row>}

                                        {current === 'allcards' && <Row
                                            style={{
                                                minHeight: "66px",
                                                display: "flex",
                                                alignItems: "center",
                                                borderBottom: "1px solid #E8E8E8",
                                                paddingTop: "10px",
                                                paddingBottom: "10px"
                                            }}
                                        >
                                            <Col
                                                xl={{span: 3}}
                                                lg={{span: 3}}
                                                md={{span: 6}}
                                                sm={{span: 6}}
                                                xs={{span: 6}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.HZDID}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 3}}
                                                lg={{span: 3}}
                                                md={{span: 9}}
                                                sm={{span: 9}}
                                                xs={{span: 9}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.dateObserved}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 3}}
                                                lg={{span: 3}}
                                                md={{span: 3}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.employee === 'anonymous' ? 'Anonymous' : data.createdBy}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 3}}
                                                lg={{span: 3}}
                                                md={{span: 3}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.observationType}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 6}}
                                                lg={{span: 6}}
                                                md={{span: 6}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                                style={{
                                                    maxHeight: "100px", 
                                                    overflowX: "hidden",
                                                    overflowY: "auto",
                                                    
                                                }}
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.observationDescription}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 0}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.actions && data.actions.items && data.actions.items.length > 0 ? data.actions.items.length : 0}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 4}}
                                                sm={{span: 4}}
                                                xs={{span: 4}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <div
                                                    className={data.status === 'open'?
                                                        "statusContainer openStatus" : data.status === 'assigned' ?
                                                            "statusContainer assignedStatus" : data.status === 'closed' ?
                                                                "statusContainer closedStatus" : data.status === 'void' ?
                                                                        "statusContainer voidStatus" : "statusContainer"
                                                    }
                                                >
                                                    <StyledDiv
                                                        className="dataText"
                                                    >
                                                        {data.status.toUpperCase()}
                                                    </StyledDiv>
                                                </div>
                                                
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 5}}
                                                sm={{span: 5}}
                                                xs={{span: 5}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <EyeFilled 
                                                    className="viewIcon"
                                                    onClick = {() => setDetailsViewModal({show: true, id: data.id})}
                                                />
                                            </Col>
                                        </Row>}

                                        {(current === 'allactions' || current === 'assignedactionstoteam') && <Row
                                            style={{
                                                minHeight: "66px",
                                                display: "flex",
                                                alignItems: "center",
                                                borderBottom: "1px solid #E8E8E8",
                                                paddingTop: "10px",
                                                paddingBottom: "10px"
                                            }}
                                        >
                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 6}}
                                                sm={{span: 6}}
                                                xs={{span: 6}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.HZDID}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 7}}
                                                lg={{span: 7}}
                                                md={{span: 7}}
                                                sm={{span: 0}}
                                                xs={{span: 0}}
                                                className="columnContainer"
                                                
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.action}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                span={4}
                                                className="columnContainer"
                                            >
                                                <StyledDiv className={overDue ? "dueDateDataText dataText" : "dataText"}>
                                                    {data.dueDate ? `${data.dueDate} ${overDue ? "!" : ""}` : "-"}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 5}}
                                                lg={{span: 5}}
                                                md={{span: 9}}
                                                sm={{span: 9}}
                                                xs={{span: 9}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <StyledDiv
                                                    className="dataText"
                                                >
                                                    {data.assignedTo}
                                                </StyledDiv>
                                            </Col>

                                            <Col
                                                xl={{span: 2}}
                                                lg={{span: 2}}
                                                md={{span: 5}}
                                                sm={{span: 5}}
                                                xs={{span: 5}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <div
                                                    className={data.status === 'open'?
                                                        "statusContainer openStatus" : data.status === 'assigned' || data.status === 'reassigned' ?
                                                            "statusContainer assignedStatus" : data.status === 'closed' ?
                                                                "statusContainer closedStatus" : data.status === 'completed' ?
                                                                    "statusContainer completedStatus" : data.status === 'void' ?
                                                                        "statusContainer voidStatus" : "statusContainer"
                                                    }
                                                >
                                                    <StyledDiv
                                                        className="dataText"
                                                    >
                                                        {data.status.toUpperCase()}
                                                    </StyledDiv>
                                                </div>
                                                
                                            </Col>

                                            <Col
                                                xl={{span: 4}}
                                                lg={{span: 4}}
                                                md={{span: 4}}
                                                sm={{span: 4}}
                                                xs={{span: 4}}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <EyeFilled 
                                                    className="viewIcon"
                                                    onClick = {() => setDetailsViewModal({show: true, id: data.Hazard.id, actionID: data.id})}
                                                />
                                            </Col>
                                        </Row>}

                                    </React.Fragment>
                                )
                            })}
                        </Col>
                    </Row>

                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "5%",
                        }}

                        className="paginationContainer"
                    >
                        {cards.length > 0 && <>
                            <Pagination
                                current={paginationDetails.currentPage}
                                onChange={handleChange}
                                total={cards.length}
                                pageSize={paginationDetails.itemsPerPage}
                                showSizeChanger={false}
                            />
                        </>}
                    </Row>
                </Col>
            </Row>
        </>
    )
}
